import {createMuiTheme} from "@material-ui/core/styles";


export const login = createMuiTheme({
    palette: {
        primary: {
            main: "rgba(0, 0, 0, 0.87)",
        },
        secondary: {
            main: "#FFF",
        },
    },
    //
    // overrides: {
    //     MuiFormHelperText: {
    //         root:{
    //             color: "red"
    //         }
    //     }
    // }
});
